import { Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";

export const styles = ({palette, spacing}: Theme) => createStyles({
    button: {
        "& span": {
            flexDirection: "inherit"
        },
        "&:nth-child(3)": {
            marginLeft: "auto"
        },
        "&:nth-child(-n+3)": {
            "& svg": {
                marginRight: spacing.unit
            }
        },
        "&:nth-child(n+3)": {
            flexDirection: "row-reverse",
            "& svg": {
                marginLeft: spacing.unit
            }
        },
        "&:last-child": {
            "& span": {
                textTransform: "capitalize"
            }
        },
        "&$buttonsDisabled" : {
            color: palette.primary.main
        }
    },
    buttonsDisabled: {

    },
    container: {
        borderBottom: `1px solid ${palette.primary.main}`,
        background: palette.grey["100"]
    },
    buttonLabel: {
        textTransform: "lowercase",
        "&:first-letter": {
            textTransform: "capitalize"
        }
    },
    menu: {
        marginTop: spacing.unit * 5.75
    },
    item: {
        fontWeight: 300
    }
});


// WEBPACK FOOTER //
// ./src/components/TopToolbar/TopToolbar.style.tsx